<template>
  <div id="bg" class="w-100">
    <UserAuthForm :submit-form="loginLocal" button-text="Login" />
    <p class="text-center mt-4">
      <!--v-slot="{ href, navigate }"-->
      <b-button variant="secondary" to="/login/forgot">
        Forgot Password
      </b-button>.
      <!--temp removing-->
      <!-- Don't have an
      account? <NuxtLink to="/register">Register</NuxtLink>. -->
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import UserAuthForm from '~/components/account/UserAuthForm.vue'

export default {
  middleware: 'guest',
  components: {
    UserAuthForm
  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    async loginLocal (userInfo) {
      debugger
      try {
        await this.$auth
          .loginWith('local', {
            data: userInfo
          })
          .then((response) => {
            console.log(response)
            this.$auth.setUser(response.data.user)
            // is this still necessary? probably - but might also be able to start using $auth.
            this.$store.commit('user', response.data.user)
            this.$store.commit('authToken', response.data.user.token)
            this.$cookies.set('authToken', response.data.user.token)

            this.$router.push({ path: '/dashboard' })
          })
          .catch((error) => {
            this.$toast.error(
              'Either email or password or wrong. Please try again'
            )
          })
      } catch (err) {
        console.log(err)
      }
    }
    // worked in staging before auth-next v5 update
    // async userLogin(userInfo) {
    //   try {
    //     const response = await this.$axios.post('/login', userInfo)
    //     this.$store.commit('user', response.data.user)
    //     this.$store.commit('authToken', response.data.token)
    //     this.$cookies.set('authToken', response.data.token)
    //     this.$router.push('/dashboard')
    //   } catch (error) {
    //     this.$toast.error('Incorrect username or password. Please try again.')
    //   }
    // }
  }
}
</script>

<style scoped>
/* #bg {
  background: url('https://s3.amazonaws.com/wox-drops/img/landingBG.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100%;
} */
</style>
